import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useHomeReadyContent } from '../../../../hooks/useHomeReadyContent';
import './Ready.css';

const Ready = () => {
  const { content, isLoading } = useHomeReadyContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="ready">
      <div className="ready__inner">
        <Reveal className="ready__content">
          <h2 className="ready__title">{title}</h2>
          <p className="ready__text">{text}</p>
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="ready__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default Ready;
